import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist'

Vue.use(Vuex);

//fallback
const STORE_STATE = {INITIALIZED: 0, CLEAR: 1, UNSAVED: 2};

const vuexPersist = new VuexPersist({
  key: 'mybikesetup',
  storage: localStorage
});

export const storageService = new Vuex.Store({
  strict: true,
  plugins: [vuexPersist.plugin],
  getters: {
    uuid: state => state.uuid,
    allBikes: state => {
      return state.bikes;
    },
    state: s => {
      return s.state;
    },
    setup: state => setupId => {
      console.log('setup load');
      var list = [];

      var bikes = state.bikes;
      for (var i = 0; bikes != null && i != bikes.length; i++) {
        list = list.concat(bikes[i].setups);
      }
      console.log('setup load done');
      return list.find(setup => setup.id == setupId);
    },
    bike: state => bikeId => {
      return state.bikes.find(bike => bike.id == bikeId);
    },
    apiKey: state => state.apiKey
  },

  mutations: {
    createNewSettings: state => {
      state.bikes = state._defaultBikes;
      state.state = STORE_STATE.CLEAR;
    },

    updateSettings: (state, payload) => {
      state.uuid = payload.uuid;
      state.revision = payload.revision;
      state.state = payload.state;
    },

    updateTodo: (state, payload) => {
      var bike = state.bikes.find(b => b.id == payload.bikeId);
      var todo = bike.todos.find(todo => todo.id == payload.todoId)
      if (payload.checked) {
        todo.checked = payload.checked;
        state.state = STORE_STATE.UNSAVED;
      }
      if (payload.text) {
        todo.text = payload.text;
        state.state = STORE_STATE.UNSAVED;
      }
    },

    deleteTodo: (state, payload) => {
      var bike = state.bikes.find(b => b.id == payload.bikeId);
      for (var i = 0; i != bike.todos.length; i++) {
        if (bike.todos[i].id == payload.todoId) {
          bike.todos.splice(i, 1);
          state.state = STORE_STATE.UNSAVED;
          break
        }
      }
    },

    addTodo: (state, payload) => {
      var bike;
      var bikes = state.bikes;
      var newToDoId = 0;
      for (var i = 0; i != bikes.length; i++) {
        if (bikes[i].id == payload.bikeId) {
          bike = bikes[i];
        }

        for (var ti = 0; ti != bikes[i].todos.length; ti++) {
          if (bikes[i].todos[ti].id > newToDoId) {
            newToDoId = bikes[i].todos[ti].id;
          }
        }
      }
      if (bike == null) {
        return;
      }

      bike.todos.push({id: newToDoId + 1, text: payload.text, checked: payload.checked})

      state.state = STORE_STATE.UNSAVED;
    },

    importBikes: (state, payload) => {
      state.bikes = payload.bikes;
      state.uuid = payload.uuid;
      state.revision = payload.revision;
      state.state = STORE_STATE.CLEAR;
    },

    addSetup: (state, payload) => {
      var bikes = state.bikes;
      var maxId = 0;
      var bike;
      for (var bi = 0; bi != bikes.length; bi++) {
        for (var i = 0; i !== bikes[bi].setups.length; i++) {
          if (bikes[bi].id == payload.bikeId) {
            bike = bikes[bi];
          }
          if (bikes[bi].setups[i].id > maxId) {
            maxId = bikes[bi].setups[i].id;
          }
        }
      }
      var newSetup = {name: payload.name, forkSetups: [], shockSetups: [], miscSetups: [], id: maxId + 1};
      bike.setups.push(newSetup);
      state.lastSetup = newSetup;
      state.state = STORE_STATE.UNSAVED;
    },

    updateSetup: (state, payload) => {
      var bikes = state.bikes;
      for (var bi = 0; bi != bikes.length; bi++) {
        var bike = bikes[bi];
        for (var i = 0; i !== bike.setups.length; i++) {
          if (bike.setups[i].id == payload.setup.id) {
            if (payload.setup) {
              bike.setups[i] = payload.setup;
              state.state = STORE_STATE.UNSAVED;
            }
            if (payload.name) {
              bike.setups[i].name = payload.name;
              state.state = STORE_STATE.UNSAVED;
            }
            return;
          }
        }
      }
    },
    deleteSetup: (state, payload) => {
      var bikes = state.bikes;
      for (var bi = 0; bi != bikes.length; bi++) {
        for (var i = 0; i < bikes[bi].setups.length; i++) {
          if (bikes[bi].setups[i].id == payload.setupId) {
            bikes[bi].setups.splice(i, 1);
            state.state = STORE_STATE.UNSAVED;
          }
        }
      }
    },

    copySetup: (state, payload) => {
      var bikes = state.bikes;
      var maxId = 0;
      var bike;
      var newSetup = payload.setup;
      for (var bi = 0; bi != bikes.length; bi++) {
        for (var i = 0; i !== bikes[bi].setups.length; i++) {
          if (bikes[bi].setups[i].id == newSetup.id) {
            bike = bikes[bi];
          }
          if (bikes[bi].setups[i].id > maxId) {
            maxId = bikes[bi].setups[i].id;
          }
        }
      }
      newSetup.id = maxId + 1;
      bike.setups.push(newSetup);
      state.lastSetup = newSetup;
      state.state = STORE_STATE.UNSAVED;
    },

    addBike: (state, payload) => {
      var bikes = state.bikes;
      var maxId = 0;
      for (var i = 0; i !== bikes.length; i++) {
        if (bikes[i].id > maxId) {
          maxId = bikes[i].id;
        }
      }

      state.bikes.push({
        id: maxId + 1,
        name: payload.name,
        todos: [],
        setups: [state._defaultSetup]
      });
      state.state = STORE_STATE.UNSAVED;
    },

    updateBike: (state, payload) => {
      var bike = state.bikes.find(b => b.id == payload.bikeId);
      if (bike != null) {
        bike.name = payload.name;
        state.state = STORE_STATE.UNSAVED;
      }
    },

    deleteBike: (state, payload) => {
      var bikes = state.bikes;
      for (var i = 0; i != bikes.length; i++) {
        if (bikes[i].id == payload.bikeId) {
          bikes.splice(i, 1);
          state.state = STORE_STATE.UNSAVED;
          break
        }
      }
    },

    updateApiKey: (state, payload) => {
      state.apiKey = payload;
    },
    initMe: (state, $vuetify) => {
      state._defaultSetup = {
        'forkSetups': [{'name': $vuetify.t('$vuetify.setuptype.pressure'), 'value': '123'}, {'name': 'Lowspeed Rebound', 'value': '3'}, {
          'name': 'Highspeed Rebound',
          'value': '5'
        }, {'name': 'Lowspeed Compression', 'value': '1'}, {'name': 'Heighspeed Compression', 'value': '0'}],
        'id': 1,
        'miscSetups': [{'name': $vuetify.t('$vuetify.setuptype.pressure_front'), 'value': '1.7'}, {'name': $vuetify.t('$vuetify.setuptype.tire_rear'), 'value': '1.8'}],
        'name': 'General',
        'shockSetups': [{'name': $vuetify.t('$vuetify.setuptype.spring'), 'value': '500'}, {'name': 'Rebound', 'value': '5'}, {'name': 'Compression', 'value': '5'}]
      };

      state._defaultBikes = [{
        'id': 1,
        'name': 'Bike1',
        'setups': [{
          'forkSetups': [{'name': $vuetify.t('$vuetify.setuptype.pressure'), 'value': '123'}, {'name': 'Lowspeed Rebound', 'value': '3'}, {
            'name': 'Highspeed Rebound',
            'value': '5'
          }, {'name': 'Lowspeed Compression', 'value': '1'}, {'name': 'Heighspeed Compression', 'value': '0'}],
          'id': 1,
          'miscSetups': [{'name': $vuetify.t('$vuetify.setuptype.pressure_front'), 'value': '1.7'}, {'name': $vuetify.t('$vuetify.setuptype.tire_rear'), 'value': '1.8'}],
          'name': 'General',
          'shockSetups': [{'name': $vuetify.t('$vuetify.setuptype.spring'), 'value': '500'}, {'name': 'Rebound', 'value': '5'}, {'name': 'Compression', 'value': '5'}]
        }, {
          'forkSetups': [{'name': $vuetify.t('$vuetify.setuptype.pressure'), 'value': '1231'}, {'name': 'Highspeed Rebound', 'value': '51'}, {
            'name': 'Highspeed Compression',
            'value': '10'
          }],
          'id': 2,
          'miscSetups': [],
          'name': 'Setup 2',
          'shockSetups': [{'name': $vuetify.t('$vuetify.setuptype.pressure'), 'value': '200'}, {'name': 'Rebound', 'value': '5'}, {'name': 'Compression', 'value': '5'}]
        }, {
          'forkSetups': [{'name': $vuetify.t('$vuetify.setuptype.pressure'), 'value': '123'}, {'name': 'Lowspeed Rebound', 'value': '3'}, {
            'name': 'Highspeed Rebound',
            'value': '5'
          }, {'name': 'Lowspeed Compression', 'value': '1'}, {'name': 'Highspeed Compression', 'value': '0'}], 'id': 3, 'miscSetups': [], 'name': 'Setup 3', 'shockSetups': []
        }],
        'todos': [{'checked': false, 'id': 1, 'text': 'Todo1'}, {'checked': true, 'id': 2, 'text': 'Todo2'}, {'checked': false, 'id': 3, 'text': 'Todo3'}, {
          'checked': false,
          'id': 4,
          'text': 'Todo 1'
        }, {'checked': true, 'id': 5, 'text': 'Todo 2'}, {'checked': false, 'id': 6, 'text': 'Todo 4'}]
      }, {
        'id': 2,
        'name': 'Bike2',
        'setups': [{
          'forkSetups': [{'name': $vuetify.t('$vuetify.setuptype.pressure'), 'value': '123'}, {'name': 'Lowspeed Rebound', 'value': '3'}, {
            'name': 'Highspeed Rebound',
            'value': '5'
          }, {'name': 'Lowspeed Compression', 'value': '1'}, {'name': 'Highspeed Compression', 'value': '0'}],
          'id': 4,
          'miscSetups': [{'name': $vuetify.t('$vuetify.setuptype.pressure_front'), 'value': '1.7'}, {'name': $vuetify.t('$vuetify.setuptype.tire_rear'), 'value': '1.8'}],
          'name': 'Basic',
          'shockSetups': [{'name': $vuetify.t('$vuetify.setuptype.spring'), 'value': '500'}, {'name': 'Rebound', 'value': '5'}, {'name': 'Compression', 'value': '5'}]
        }],
        'todos': []
      }, {'id': 3, 'name': 'Bike3', 'setups': [], 'todos': []}]
    }
  },

  actions: {
    createNewSettings: (context, payload) => {
      context.commit('createNewSettings');
    },

    importBikes: (context, payload) => {
      var uuid = payload;
      if (uuid && uuid.length > 1) {
        fetch('https://whbe.mybikesetup.net/storage/' + uuid).then(function (response) {
          var contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            return response.json();
          }
          throw new TypeError('Oops, we haven\'t got JSON!');
        }).then(function (json) {
          if (json.id) {
            var bikeData = JSON.parse(json.value)
            if (bikeData) {
              context.commit('importBikes', {bikes: bikeData, uuid: json.uuid, revision: json.id});
            }
          }
        }).catch(function (error) {
          console.error(error);
        });
      }
    },

    exportBikes: context => {
      if (context.state.state == STORE_STATE.CLEAR) {
        return;
      }

      var uuid = context.state.uuid;
      if (!uuid || uuid.trim().length == 0) {
        uuid = guid() + guid() + guid();
      }

      fetch('https://whbe.mybikesetup.net/storage/' + uuid,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(context.state.bikes)
        }
      ).then(response => response.text()).then(function (id) {
        if (id) {
          context.commit('updateSettings', {uuid: uuid, revision: id, state: STORE_STATE.CLEAR});
        } else {
          console.error(':-(');
        }
      }).catch(function (error) {
        console.error(error);
      });

      //helper methods
      function guid() {
        return 'ssssssss'.replace(/s/g, s4);
      }

      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
    },

    refreshExport: context => {
      if (!context.state.uuid || context.state.uuid.trim().length === 0) {
        return;
      }

      fetch('https://whbe.mybikesetup.net/storage/' + context.state.uuid).then(function (response) {
        var contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          return response.json();
        }
        throw new TypeError('Oops, we haven\'t got JSON!');
      }).then(function (json) {
        if (json.id) {
          if (json.id > context.state.revision) {
            var bikeData = JSON.parse(json.value);
            if (bikeData) {
              context.commit('importBikes', {bikes: bikeData, uuid: json.uuid, revision: json.id});
            }
          } else {
            context.dispatch('exportBikes');
          }
        }
      }).catch(function (error) {
        console.error(error);
      });
    },

    addSetup: (context, payload) => {
      context.commit('addSetup', payload);
    },
    updateSetup: (context, payload) => {
      context.commit('updateSetup', payload);
    },
    copySetup: (context, payload) => {
      context.commit('copySetup', payload);
    },
    deleteSetup: (context, payload) => {
      context.commit('deleteSetup', payload);
    },

    addTodo: (context, payload) => {
      context.commit('addTodo', payload);
    },
    deleteTodo: (context, payload) => {
      context.commit('deleteTodo', payload);
    },
    updateTodo: (context, payload) => {
      context.commit('updateTodo', payload);
    },

    addBike: (context, payload) => {
      context.commit('addBike', payload);
    },
    updateBike: (context, payload) => {
      context.commit('updateBike', payload);
    },
    deleteBike: (context, payload) => {
      context.commit('deleteBike', payload);
    },
    updateApiKey: (context, payload) => {
      context.commit('updateApiKey', payload);
    }
  },

  state: {
    state: 0,
    revision: -1,
    uuid: null,
    bikes: [],
    lastSetup: null,
    _defaultSetup: null,
    _defaultBikes: null,
    apiKey: ''
  }
});



// WEBPACK FOOTER //
// ./src/components/StorageService.js